import React, { CSSProperties, FC, HTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './checklist.module.scss'

interface ChecklistItemProps extends HTMLAttributes<HTMLDivElement> {
  margin?: string
  fontSize?: string
  color?: string
}

export const ChecklistItem: FC<ChecklistItemProps> = ({
  margin,
  fontSize,
  color,
  className,
  style,
  children,
  ...rest
}) => (
  <div
    className={cn(classes.checklistItem, className)}
    style={
      {
        ...style,
        '--checklist-margin': margin,
        '--checklist-font-size': fontSize,
        '--checklist-color': color,
      } as CSSProperties
    }
    {...rest}
  >
    {children}
  </div>
)
